/** The bots' pictures (owner, 13 Sept 2026; masters in `docs/ui/assets`): gold, blue, purple. */
const BOT_AVATARS = ["/avatars/bot1.webp", "/avatars/bot2.webp", "/avatars/bot3.webp"] as const;

/**
 * A bot's picture from its number, fixed when the bot was made (`bot:<table>:<n>`): the
 * three bots that fill a table always look different and never change mid-game. Pure.
 */
export function botAvatar(userId: string): string {
  const n = Number(userId.slice(userId.lastIndexOf(":") + 1));
  const index = Number.isInteger(n) && n > 0 ? (n - 1) % BOT_AVATARS.length : 0;
  return BOT_AVATARS[index] ?? BOT_AVATARS[0];
}
